package com.essntl.features.message.data.repository

import com.essntl.features.message.domain.model.WhapiChatModel
import com.essntl.features.message.domain.model.WhapiMessageModel
import com.essntl.features.message.domain.repository.ConversationRepository

class ConversationMockRepository : ConversationRepository {
    private val conversations = listOf(
        WhapiChatModel(
            id = "001",
            timestamp = 1721293427,
            unreadCount = 2,
            lastMessage = WhapiMessageModel(
                id = "0002",
                chatId = "001",
                fromMe = false,
                fromName = "Michael Lee",
                from = "",
                timestamp = 1721293427,
                text = "I would like to clarify the details of the service.",
                type = WhapiMessageModel.Type.Text,
                action = null,
                linkPreviewModel = null,
                status = WhapiMessageModel.Status.Read,
                source = "api",
            ),
            name = "Michael Lee",
            phoneNumber = "",
            type = WhapiChatModel.ChatType.Contact,
            source = "api",
            participants = null,
        ),
        WhapiChatModel(
            id = "002",
            timestamp = 1721293427,
            unreadCount = 0,
            lastMessage = WhapiMessageModel(
                id = "0003",
                chatId = "002",
                fromMe = true,
                fromName = "Mary Harvey",
                from = "",
                timestamp = 1721293427,
                text = "Dear Mrs. Harvey, tomorrow, Wednesday",
                type = WhapiMessageModel.Type.Text,
                action = null,
                linkPreviewModel = null,
                status = WhapiMessageModel.Status.Read,
                source = "api",
            ),
            name = "Mary Harvey",
            phoneNumber = "",
            type = WhapiChatModel.ChatType.Contact,
            source = "api",
            participants = null,
        ),
        WhapiChatModel(
            id = "003",
            timestamp = 1721293427,
            unreadCount = 1,
            lastMessage = WhapiMessageModel(
                id = "0006",
                chatId = "003",
                fromMe = false,
                fromName = "Nancy Noelene",
                from = "",
                timestamp = 1721293427,
                text = "Thank you",
                type = WhapiMessageModel.Type.Text,
                action = null,
                linkPreviewModel = null,
                status = WhapiMessageModel.Status.Read,
                source = "api",
            ),
            name = "Nancy Noelene",
            phoneNumber = "",
            type = WhapiChatModel.ChatType.Contact,
            source = "api",
            participants = null,
        ),
        WhapiChatModel(
            id = "004",
            timestamp = 1721293427,
            unreadCount = 0,
            lastMessage = WhapiMessageModel(
                id = "0007",
                chatId = "004",
                fromMe = true,
                fromName = "Elaine Williams",
                from = "",
                timestamp = 1721293427,
                text = "Dear Mrs. Williams, tomorrow, Wednesday",
                type = WhapiMessageModel.Type.Text,
                action = null,
                linkPreviewModel = null,
                status = WhapiMessageModel.Status.Read,
                source = "api",
            ),
            name = "Elaine Williams",
            phoneNumber = "",
            type = WhapiChatModel.ChatType.Contact,
            source = "api",
            participants = null,
        ),
    )

    override suspend fun getWhapiChats(page: Long): Result<List<WhapiChatModel>> =
        Result.success(conversations)

    override suspend fun getWhapiChatById(chatId: String): Result<WhapiChatModel> =
        Result.success(conversations.first { it.id == chatId })

    override suspend fun updateWhapiChat(chatId: String, markUnread: Boolean): Result<Unit> {
        TODO("Not yet implemented")
    }

    override suspend fun getWhapiGroups(): Result<List<WhapiChatModel>> {
        TODO("Not yet implemented")
    }

    override suspend fun getWhapiGroupById(groupId: String): Result<WhapiChatModel> {
        TODO("Not yet implemented")
    }
}